import aws4 from 'aws4';
import Vue from 'vue';
import axios, { AxiosRequestConfig, Method } from 'axios';
import { AWSCredentialsModel } from '@/@types/member';

interface Data {
    awsCredentials: AWSCredentialsModel;
  }

export default Vue.extend({

    data(): Data {
        return {
          awsCredentials: {
            secretAccessKey: '',
            accessKeyId: '',
            sessionToken: '',
          },
        };
      },

    methods: {
        setAwsCredentials(
            secretAccessKey: string,
            accessKeyId: string,
            sessionToken: string,
        ) {
            this.awsCredentials.secretAccessKey = secretAccessKey;
            this.awsCredentials.accessKeyId = accessKeyId;
            this.awsCredentials.sessionToken = sessionToken;
        },

        awsRequest(
            method: Method,
            url: string,
            data?: any,
        ) {
            const baseURL = process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_SAM_API_URL : `${window.location.origin}/`;
            url = baseURL + url;
            const awsRequestOptions: any = {
                host: new URL(url).host,
                method,
                path: new URL(url).pathname,
                body: JSON.stringify(data),
                service: 'execute-api',
                region: 'us-east-2',
                headers: {
                    'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
                    ... (process.env.VUE_APP_CLIENT_VERSION ? { 'x-app-version': process.env.VUE_APP_CLIENT_VERSION} : {}),
                },
            };
            if (data) {
                awsRequestOptions.headers['Content-Type'] = 'application/json';
            }
            aws4.sign(awsRequestOptions, {
                secretAccessKey: this.awsCredentials.secretAccessKey,
                accessKeyId: this.awsCredentials.accessKeyId,
                sessionToken: this.awsCredentials.sessionToken,
            });
            // remove unsafe headers
            delete awsRequestOptions.headers.Host;
            delete awsRequestOptions.headers['Content-Length'];
            return axios({
                url,
                method,
                data,
                headers: awsRequestOptions.headers,
            } as AxiosRequestConfig);
        },

    },
});
